import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Spinner } from 'reactstrap';
import Api from 'services/api';
import { setInterpreterIframeUrl, setInterpreterAppid } from 'slices/interpreter/interpreterIframeSlice';

const QuickJoin = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);

  useEffect(() => {
    Api.quickJoinVriCall(id).then((res) => {
      if (res?.status === 200 && res?.data?.data?.iframe_url) {
        const { iframe_url, appointment, is_replacement } = res.data.data;
        dispatch(setInterpreterIframeUrl(iframe_url));
        dispatch(setInterpreterAppid(appointment?.appid));
        navigate(
          `/interpreter/appointments/view/${appointment?.id}/join-room-call`,
          { state: { isReplacement: is_replacement === true }, replace: true }
        );
      } else {
        setError(res?.data?.message || 'Unable to join. The appointment may already be taken or completed.');
      }
    });
  }, [id]);

  if (error) {
    return (
      <div className="content d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
        <p className="text-danger text-center" style={{ maxWidth: 420, fontSize: 16 }}>{error}</p>
        <button className="btn btn-primary mt-3" onClick={() => navigate('/interpreter/dashboard')}>
          Go to Dashboard
        </button>
      </div>
    );
  }

  return (
    <div className="content d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
      <Spinner color="primary" />
      <p className="mt-3 text-muted">Joining call…</p>
    </div>
  );
};

export default QuickJoin;
